import Vue from 'vue'
let vm = new Vue()

let showLoad = function() {
	vm.$loading('加载中...')
}

let hideLoad = function() {
	vm.$loading.close();
}

let toast = function(data) {
	vm.$toast(data);
}

/**
 * @lastTime  {[number]}   活动截止日期的时间戳
 * @return {[String]}   活动倒计时
 */
let fromDateQ = function(lastTime) {

	let newData = new Date().getTime();
	lastTime = lastTime - newData
	var day = Math.floor(lastTime / 86400000); // 天
	lastTime = lastTime - 86400000 * day
	var hour = Math.floor(lastTime / 3600000); //小时
	lastTime = lastTime - 3600000 * hour
	var minute = Math.floor(lastTime / 60000); //分
	lastTime = lastTime - 60000 * minute
	var second = Math.floor(lastTime / 1000); //秒

	if (day == 0 && hour == 0 && minute == 0 && second == 0) {
		for (let i = 0; i < 9999; i++) {
			window.clearInterval(i)
		}
	}
	return `${day}天${hour}时${minute}分${second}秒`
}

/**
 * @lastTime  {[number]}   团截止日期的时间戳
 * @return {[String]}   团倒计时
 */
let fromDateTuan = function(lastTime, type) {

	let newData = new Date().getTime();
	lastTime = lastTime - newData
	var hour = Math.floor(lastTime / 3600000); //小时
	lastTime = lastTime - 3600000 * hour
	var minute = Math.floor(lastTime / 60000); //分
	lastTime = lastTime - 60000 * minute
	var second = Math.floor(lastTime / 1000); //秒

	if (type === 'h') {
		hour = String(hour).padStart(2, 0)
		return hour
	}
	if (type === 'm') {
		minute = String(minute).padStart(2, 0)
		return minute
	}
	if (type === 's') {
		second = String(second).padStart(2, 0)
		return second
	}

	if (hour < 0 || minute < 0 || second < 0) {
		for (let i = 0; i < 9999; i++) {
			window.clearInterval(i)
		}
	}
}

/**
 * 
 * @param {string} name 获取url参数 
 */
let getUrlParameter = function(name) {

	var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	var r = window.location.search.substr(1).match(reg);
	if (r != null) {
		return unescape(r[2]);
	}
	return null;

}


let setSto = function(name, val) {
	localStorage.setItem(name, val);
}

let getSto = function(name) {
	return localStorage.getItem(name)
}

let removeSto = function(name) {
	return localStorage.removeItem(name)
}

let setStoObj = function(name, val) {
	val = JSON.stringify(val)
	localStorage.setItem(name, val);
}

let getStoObj = function(name) {
	return JSON.parse(localStorage.getItem(name))
}


let goUrl = function(url) {
	window.location = url
}

// 校验手机号
let checkTel = function(tel) {
	var re = /^1\d{10}$/;
	if (re.test(tel)) {
		return true;
	} else {
		return false;
	}
}

// 校验车牌号
let checkPlant = function(str) {
	let res =
		/^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/
		.test(str);
	return res;
}

// IOS页面返回不刷新
let iosReload = function() {
	//解决IOS返回页面不刷新的问题
	var u = navigator.userAgent;
	var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	if (isiOS) {
		var isPageHide = false;
		window.addEventListener('pageshow', function() {
			if (isPageHide) {
				window.location.reload();
			}
		});
		window.addEventListener('pagehide', function() {
			isPageHide = true;
		});
	}
}

let verified = function(verifing) {
	let flag = false;
	if (!verifing || verifing.length == 0) {
		return true;
	}
	for (let i = 0; i < verifing.length; i++) {
		flag = this[verifing[i].name](verifing[i].content, verifing[i].tip);
		if (!flag) {
			break;
		}

	}
	return flag;
}

let isLengthZero = function(content, tip) {
	if (content.length) {
		return true;
	} else {
		toast(tip);
		return false;
	}
}
let isEmpty = function(input, tip, that) {
	if (input === '' || input === null || input === undefined) {
		if (input === 0) {
			return true;
		} else {
			toast(tip);
			return false;
		}
	} else {
		return true;
	}
}

let mobile = function(phone, tip) {
	if (!!phone && phone.length === 11) {
		return true;
	} else {
		toast(tip);
		return false;
	}
}

// 校验用户购买产品  输入框 不能为0  不能为小数
let checkBuyIpt = function(num) {
	if (!(/(^[1-9]\d*$)/.test(num))) {
		return false
	} else {
		return true;
	}
}

// 区分安卓IOS
let isAndroid = function() {
	var u = navigator.userAgent;
	var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
	var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	if (isAndroid) {
		return true;
	} else if (isiOS) {
		return false;
	}
}
// 数组去重
let deteleObject = function(obj) {
	var uniques = [];
	var stringify = {};
	for (var i = 0; i < obj.length; i++) {
		var keys = Object.keys(obj[i]);
		keys.sort(function(a, b) {
			return (Number(a) - Number(b));
		});
		var str = '';
		for (var j = 0; j < keys.length; j++) {
			str += JSON.stringify(keys[j]);
			str += JSON.stringify(obj[i][keys[j]]);
		}
		if (!stringify.hasOwnProperty(str)) {
			uniques.push(obj[i]);
			stringify[str] = true;
		}
	}
	uniques = uniques;
	return uniques;
}
export default {
	fromDateQ,
	fromDateTuan,
	showLoad,
	hideLoad,
	toast,
	getUrlParameter,
	setSto,
	setStoObj,
	removeSto,
	getSto,
	getStoObj,
	goUrl,
	checkTel,
	checkPlant,
	iosReload,
	verified,
	isLengthZero,
	isEmpty,
	mobile,
	checkBuyIpt,
	isAndroid,
	deteleObject
}
